import AuthStore from 'auth/AuthStore'
import { snackbar } from 'reusable/mui/snackbar/snackbar'
import Loader from 'reusable/mobx-helpers/Loader'
import { confirmSignIn } from 'aws-amplify/auth'
import { FormHandlerConfig, formHandler } from 'reusable/mobx-store-utils/form-handlers/new/form-handler'
import validation from '@gap/utils/validation/validation-constants'
import { snackbarError } from 'reusable/mui/snackbar/snackbar'
import { makeAutoObservable } from 'mobx'
import validatePassword from 'auth/validate/validatePassword'

export default class AuthSignInNewPasswordRequiredStore {
   authStore
   loader = new Loader()
   fields = {
      newPassword: '',
      confirmPassword: ''
   }

   constructor(authStore: AuthStore) {
      this.authStore = authStore
      makeAutoObservable(this)
   }

   get formHandler() {
      return formHandler(this.fields, {
         oldPassword: { type: 'string' },
         newPassword: { type: 'string' },
         confirmPassword: { type: 'string' },
      } satisfies FormHandlerConfig)
   }

   validatePasswordsMatch = () => {
      if (!!this.fields.newPassword.length &&
         !!this.fields.confirmPassword.length &&
         this.fields.newPassword !== this.fields.confirmPassword
      ) {
         this.formHandler.newPassword.setError('Passwords must match')
         this.formHandler.confirmPassword.setError('Passwords must match')
      } else {
         this.formHandler.newPassword.resetError()
         this.formHandler.confirmPassword.resetError()
      }
   }

   validateChangePassword() {
      const { formHandler, fields } = this
      formHandler.errorHandler.reset()

      this.validatePasswordsMatch()

      validatePassword(formHandler.newPassword)

      if (!fields.newPassword) {
         formHandler.newPassword.setError(validation.requiredFieldText)
      }
      if (!fields.confirmPassword) {
         formHandler.confirmPassword.setError(validation.requiredFieldText)
      }
      if (formHandler.errorHandler.hasError) {
         return false
      }
      return true
   }

   updatePassword = async () => {
      if (!this.validateChangePassword()) {
         return
      }
      this.loader.executeLoading(async () => {
         try {
            await confirmSignIn({
               challengeResponse: this.fields.newPassword
            })
         } catch (error: unknown) {
            const isError = error instanceof Error
            if (!isError) {
               snackbarError(`${error}`)
               return
            }
            switch (error.name) {
               case 'ChangePasswordException':
                  snackbar({
                     title: `Password change failed. Please try again or contact support.`,
                     variant: 'error',
                  })
                  break
               default:
                  snackbar({ title: `${error.message ?? error}`, variant: 'error' })
            }
         }
      })
   }
}
